import { section } from "shared/data";

export const StyleMainSectionPath = [section.magazine.entityId, section.style.entityId];

export const MagazinesStyleVariant = "magazines-style";
export type TypeMagazinesStyleVariant = typeof MagazinesStyleVariant;
